export enum CancellationType {
  CARE_INITIATED = 'CARE_INITIATED',
  CONTENT_TOU_VIOLATION_GENERIC = 'CONTENT_TOU_VIOLATION_GENERIC',
  COPYRIGHT_CONTENT = 'COPYRIGHT_CONTENT',
  FEEDBACK_RESOLUTION = 'FEEDBACK_RESOLUTION',
  INAPPROPRIATE_CONTENT = 'INAPPROPRIATE_CONTENT',
  LOW_INVENTORY = 'LOW_INVENTORY',
  PAYMENT_FAILURE = 'PAYMENT_FAILURE',
  PAYMENT_FRAUD_DECLINED = 'PAYMENT_FRAUD_DECLINED',
  PAYMENT_PAST_DUE = 'PAYMENT_PAST_DUE',
  SHOPPER_INITIATED = 'SHOPPER_INITIATED',
}

export const getTranslationKeyFromCancellationType = (
  cancellationType: CancellationType
): string => {
  let translationKey = '';
  switch (cancellationType) {
    case CancellationType.CARE_INITIATED:
      translationKey = 'careInitiated';
      break;
    case CancellationType.CONTENT_TOU_VIOLATION_GENERIC:
      translationKey = 'termsOfUseViolation';
      break;
    case CancellationType.COPYRIGHT_CONTENT:
      translationKey = `copyrightViolation`;
      break;
    case CancellationType.FEEDBACK_RESOLUTION:
      translationKey = `embroideryAutoCancel`;
      break;
    case CancellationType.INAPPROPRIATE_CONTENT:
      translationKey = `contentViolation`;
      break;
    case CancellationType.LOW_INVENTORY:
      translationKey = `lowInventory`;
      break;
    case CancellationType.PAYMENT_FAILURE:
    case CancellationType.PAYMENT_FRAUD_DECLINED:
    case CancellationType.PAYMENT_PAST_DUE:
      translationKey = `paymentIssue`;
      break;
    case CancellationType.SHOPPER_INITIATED:
      translationKey = `customerInitiated`;
      break;
    default:
      translationKey = '';
  }
  return translationKey;
};
